import { render, staticRenderFns } from "./cliente.vue?vue&type=template&id=cb612fde&scoped=true"
import script from "./cliente.vue?vue&type=script&lang=js"
export * from "./cliente.vue?vue&type=script&lang=js"
import style0 from "./cliente.vue?vue&type=style&index=0&id=cb612fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb612fde",
  null
  
)

export default component.exports